import React, { useMemo, useCallback, useState } from "react";
import { Facet } from "@elastic/react-search-ui";
import { useTranslation } from "react-i18next";
import config, { productSorting } from "../../../../config";
import queryString from "../../../../helpers/queryString";

const filterProject = (parentChild) => {
  if (!parentChild.includes("##")) {
    return false;
  }

  const [parent, child] = parentChild.split("##");
  if (parent && child) {
    return true;
  } else {
    return false;
  }
};

const drupalFilePath = config.filePath;

const productCategoryImagesMap = {
  リレー: "react-app-images/relays.png",
  Relays: "react-app-images/relays.png",
  继电器: "react-app-images/relays.png",
  スイッチ: "react-app-images/switches.png",
  Switches: "react-app-images/switches.png",
  开关: "react-app-images/switches.png",
  センサ: "react-app-images/sensors.png",
  Sensors: "react-app-images/sensors.png",
  传感器: "react-app-images/sensors.png",
  コネクタ: "react-app-images/connectors.png",
  Connectors: "react-app-images/connectors.png",
  连接器: "react-app-images/connectors.png",
};

const OmronProductFacet = ({ options }) => {
  const { t } = useTranslation();
  const [parentCategoryCount, setParentCategoryCount] = useState({});

  const parentChildCategories = useMemo(() => {
    const pCount = {};
    const parentChildCategories = options
      .filter(({ value }) => filterProject(value))
      .map((option) => {
        const parentChild = option.value;
        const [parentCategory, childCategory] = parentChild.split("##");
        const c = (pCount[parentCategory] || 0) + option.count;
        pCount[parentCategory] = c;
        return {
          value: parentChild,
          parentCategory,
          childCategory,
          checked: option.selected,
          ...option,
        };
      })
      .reduce((groups, item) => {
        const key = item.parentCategory;
        groups[key] = groups[key] || [];
        groups[key].push(item);
        return groups;
      }, {});
    setParentCategoryCount(pCount);

    return parentChildCategories;
  }, [options]);

  const getProductFilterLink = useCallback((value) => {
    const searchJson = {
      filters: [
        {
          field: "field_faq_product_parent_child_category",
          values: [value || ""],
          type: "all",
        },
      ],
    };

    const redirectUrl = `${config.faqSearchAppUrl}?${queryString.stringify(
      searchJson,
    )}`;
    return redirectUrl;
  }, []);

  const getProductCategoryFilterLink = useCallback((value) => {
    const searchJson = {
      filters: [
        {
          field: "field_faq_product_categories",
          values: [value || ""],
          type: "all",
        },
      ],
    };

    const redirectUrl = `${config.faqSearchAppUrl}?${queryString.stringify(
      searchJson,
    )}`;
    return redirectUrl;
  }, []);

  const getProductCategoryImage = useCallback((categoryName) => {
    return productCategoryImagesMap[categoryName]
      ? drupalFilePath + productCategoryImagesMap[categoryName]
      : "";
  }, []);

  const sortedParent = Reflect.ownKeys(parentChildCategories).toSorted(
    (a, b) =>
      (productSorting[config.appLanguage][a] || 0) -
      (productSorting[config.appLanguage][b] || 0),
  );

  return (
    <div className="p-category">
      <h2 className="c-title--subtitle-border">{t("Search by category")}</h2>
      <div className="u-flex">
        {sortedParent.map((parentCategory) => {
          const childCategories = parentChildCategories[parentCategory];
          return (
            <div key={parentCategory} className="u-flex3 u-flex6_l">
              <figure>
                <img src={getProductCategoryImage(parentCategory)} alt="" />
              </figure>
              <p className="u-link--l">
                <a href={getProductCategoryFilterLink(parentCategory)}>
                  {parentCategory}
                </a>
                {/* <a href={getProductCategoryFilterLink(parentCategory)}>
                  {parentCategory} ({parentCategoryCount[parentCategory]})
                </a> */}
              </p>
              <ul className="p-category__list">
                {childCategories.map((option) => {
                  return (
                    <li key={option.value}>
                      <a href={getProductFilterLink(option.value)}>
                        {option.childCategory} (
                        {option.count.toLocaleString("en")})
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const ProductFacetComponent = () => (
  <Facet
    field="field_faq_product_parent_child_category"
    label=""
    show={1000}
    view={(props) => <OmronProductFacet {...props} />}
  />
);

export default ProductFacetComponent;
